import { message, Input, Select, Alert } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Form,
  ModalItem,
  FormItem,
  SelectItem,
  cuentaMask,
  InputItem,
  InputNumberItem,
  ButtonItem,
  SwitchItem,
  ErrorItem,
  TextAreaItem,
  TourItem,
} from "../../../../Components/Items";
import { PlusOutlined } from "@ant-design/icons";
import AgregarCuentaContable from "../../CuentasContables/AgregarCuentaContable/AgregarCuentaContable";
import AsistenteDepreciacionLISR from "../../../../Components/AsistenteDepreciacionLISR";

const { Option } = Select;

// Las 5 cuentas que necesita un Tipo de Activo, cada una con su propio flag
// independiente de "genera cuenta hija" (ver plan del módulo).
const CUENTAS = [
  { campo: "cuentaActivoId", flag: "generarCuentaHijaActivo", label: "Cuenta del Activo", tooltip: "Cuenta contable donde se registra el costo de adquisición. Se carga al alta de cada unidad y se cancela (abona) al venderla o darla de baja. NUNCA se toca en las corridas periódicas de depreciación." },
  { campo: "cuentaDepreciacionAcumuladaId", flag: "generarCuentaHijaDepreciacionAcumulada", label: "Cuenta de Depreciación Acumulada", tooltip: "Cuenta contable (contra-activo) que se abona en cada corrida periódica de depreciación, y se cancela (carga) al vender o dar de baja la unidad." },
  { campo: "cuentaCostoGastoActivoId", flag: "generarCuentaHijaCostoGastoActivo", label: "Cuenta de Costo o Gasto", tooltip: "Cuenta de resultados que se carga (gasto) en cada corrida periódica de depreciación. Solo se usa para la depreciación periódica, no en venta ni baja." },
  { campo: "cuentaUtilidadActivoId", flag: "generarCuentaHijaUtilidadActivo", label: "Cuenta de Utilidad de Activo", tooltip: "Se abona solo cuando se VENDE un activo por un precio mayor a su valor en libros (la diferencia es una utilidad)." },
  { campo: "cuentaPerdidaActivoId", flag: "generarCuentaHijaPerdidaActivo", label: "Cuenta de Pérdida de Activo", tooltip: "Se carga cuando se vende un activo por menos de su valor en libros, o cuando se da de baja (desecho/siniestro/donación) por el valor en libros restante." },
];

class AgregarTipoDeActivo extends Component {
  formRef = React.createRef();
  refNombre = React.createRef();
  refCuentas = React.createRef();
  refDepreciacion = React.createRef();
  refFolio = React.createRef();
  state = {
    loading: false,
    openTour: false,
    openAsistenteDepreciacion: false,
    objetoCuentaContable: null,
    modalAgregarCuentaContable: false,
  };
  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible && this.props.visible)
      this.consultarTodo();
  }
  cerrarAgregarTipoDeActivo(codigo) {
    this.props.cerrarAgregarTipoDeActivo(codigo);
  }
  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post(
        "cuentascontables/selectCuentasContables",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            objetoCuentaContable: res.data.map((value) => (
              <Option value={value._id} key={value._id}>
                {cuentaMask(value.nivel1 + value.nivel2 + value.nivel3 + value.nivel4 + value.nivel5) + " - " + value.descripcion}
              </Option>
            )),
          });
        }
      });
    this.setState({ loading: false });
  }
  onFinishFailed(e) {
    ErrorItem(e);
  }
  onFinish(values) {
    this.setState({ loading: true });
    axios
      .post(
        "activosFijos/agregarTipoDeActivo",
        { ...values, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Se ha registrado un Tipo de Activo");
          this.formRef.current.resetFields();
          this.cerrarAgregarTipoDeActivo(res.data.codigo);
        } else {
          message.error(res.data.message || "Hubo un error y el Tipo de Activo no se registró");
        }
      });
  }
  abrirAgregarCuentaContable() {
    this.setState({ modalAgregarCuentaContable: true });
  }
  cerrarAgregarCuentaContable() {
    this.setState({ modalAgregarCuentaContable: false });
    this.consultarTodo();
  }
  renderCuenta({ campo, flag, label, tooltip }) {
    return (
      <React.Fragment key={campo}>
        <FormItem label={label} margin tooltip={{ title: tooltip }}>
          <Input.Group compact>
            <FormItem name={campo} required noStyle>
              <SelectItem placeholder={label} width="65%">
                {this.state.objetoCuentaContable}
              </SelectItem>
            </FormItem>
            <ButtonItem
              blanco
              icon={<PlusOutlined />}
              style={{ width: "15%" }}
              onClick={this.abrirAgregarCuentaContable.bind(this)}
            />
            <FormItem name={flag} valuePropName="checked" noStyle initialValue={false}>
              <SwitchItem
                checkedChildren="Genera hija"
                unCheckedChildren="Compartida"
                style={{ width: "20%", marginLeft: 8 }}
              />
            </FormItem>
          </Input.Group>
        </FormItem>
      </React.Fragment>
    );
  }

  // Mercancias en transito: no es una de las 5 cuentas del activo (no clona
  // subcuenta hija) pero hace falta para comprar un activo fijo con el flujo
  // "capturo la factura ahora y recibo despues", donde la poliza de la factura
  // deja el valor en transito y la de la recepcion lo abona.
  renderCuentaTransito() {
    return (
      <FormItem
        label="Cuenta de Mercancías en Tránsito"
        margin
        tooltip={{
          title:
            "Solo se usa al comprar: si capturas la factura sin recibir todavía, el valor del activo queda en esta cuenta y se abona al momento de recibirlo. Si siempre recibes junto con la factura o compras por Orden de Compra, puedes dejarla vacía.",
        }}
      >
        <Input.Group compact>
          <FormItem name="cuentaTransitoId" noStyle>
            <SelectItem placeholder="Cuenta de Mercancías en Tránsito" width="85%">
              {this.state.objetoCuentaContable}
            </SelectItem>
          </FormItem>
          <ButtonItem
            blanco
            icon={<PlusOutlined />}
            style={{ width: "15%" }}
            onClick={this.abrirAgregarCuentaContable.bind(this)}
          />
        </Input.Group>
      </FormItem>
    );
  }
  render() {
    const steps = [
      {
        title: "Tipo de Activo",
        description: "Un Tipo de Activo es la 'categoría contable' de tus activos fijos (ej. Mobiliario, Equipo de Cómputo, Vehículos). Define las cuentas de mayor y las reglas de depreciación por default que heredarán todos los Activos de este tipo.",
        target: null,
      },
      {
        title: "Nombre y Descripción",
        description: "Identifica el Tipo de Activo, ej. 'Equipo de Cómputo'.",
        target: () => this.refNombre.current,
      },
      {
        title: "Las 5 cuentas contables",
        description: "Cada cuenta tiene su propio switch 'Genera cuenta hija / Compartida': si lo activas, cada Activo de este tipo tendrá su propia subcuenta contable (clonada una sola vez al crearlo); si lo dejas apagado, todos los Activos de este tipo comparten la misma cuenta.",
        target: () => this.refCuentas.current,
      },
      {
        title: "Método y frecuencia de depreciación",
        description: "Fórmula de línea recta: Depreciación anual = (Costo − Valor Residual) × Depreciación Anual %. La frecuencia define cada cuánto se corre esa depreciación (mensual, bimestral, etc.) — se le puede hacer override a cada Activo individualmente.",
        target: () => this.refDepreciacion.current,
      },
      {
        title: "Reglas de folio",
        description: "El prefijo y la longitud definen cómo se ve el folio/serie que se autogenera para cada unidad física (ej. prefijo 'MOB-' y longitud 5 producen folios MOB-00001, MOB-00002...).",
        target: () => this.refFolio.current,
      },
    ];
    return (
      <>
        <ModalItem
          title={
            <span>
              Agregar Tipo de Activo{" "}
              <ButtonItem type="link" size="small" blanco onClick={() => this.setState({ openTour: true })}>¿Cómo funciona?</ButtonItem>
              <ButtonItem type="link" size="small" blanco onClick={() => this.setState({ openAsistenteDepreciacion: true })}>Asistente de Depreciación (Ley ISR)</ButtonItem>
            </span>
          }
          visible={this.props.visible}
          spinning={this.state.loading}
          onCancel={this.cerrarAgregarTipoDeActivo.bind(this)}
          paddingTop
          width={700}
        >
          <Form
            ref={this.formRef}
            name="agregarTipoDeActivo"
            layout
            bottom={
              <ButtonItem type="primary" htmlType="submit" style={{ display: "block", margin: "0 0 0 auto" }}>
                Agregar
              </ButtonItem>
            }
            onFinish={this.onFinish.bind(this)}
            onFinishFailed={this.onFinishFailed}
          >
            <div ref={this.refNombre}>
              <FormItem name="nombre" label="Nombre" required max={100} margin pattern tooltip={{ title: "Nombre de la categoría, ej. 'Equipo de Cómputo', 'Mobiliario', 'Vehículos'." }}>
                <InputItem placeholder="Nombre" />
              </FormItem>
              <FormItem name="descripcion" label="Descripción" margin pattern tooltip={{ title: "Descripción libre de qué tipo de bienes agrupa esta categoría." }}>
                <TextAreaItem placeholder="Descripción" />
              </FormItem>
            </div>

            <div ref={this.refCuentas}>
              <Alert
                type="info"
                showIcon
                style={{ marginBottom: 12 }}
                message="Qué hace “Genera hija”"
                description={
                  <span>
                    Con el switch en <strong>Genera hija</strong>, cada Activo de este tipo recibe su propia subcuenta, clonada de la cuenta de aquí abajo. Se crea <strong>una sola vez, al dar de alta el Activo</strong> — no por cada unidad física.
                    Con el switch en <strong>Compartida</strong>, todos los Activos de este tipo usan la misma cuenta.
                    Cada cuenta tiene su propio switch, y un Activo puede saltarse esta regla si al darlo de alta captura su propia cuenta.
                  </span>
                }
              />
              {CUENTAS.map((cuenta) => this.renderCuenta(cuenta))}
              {this.renderCuentaTransito()}
            </div>

            <div ref={this.refDepreciacion}>
              <Alert
                type="info"
                showIcon
                style={{ marginBottom: 12 }}
                message="Fórmula de depreciación (Línea Recta)"
                description={
                  <span>
                    <strong>Depreciación anual = (Costo de adquisición − Valor Residual) × Depreciación Anual %</strong>. La depreciación mensual es ese monto entre 12, y cada corrida deprecia los meses de la frecuencia elegida.
                    Ej. costo $36,000, residual 0%, depreciación anual 33.33% → se deprecian $1,000 cada mes hasta llegar a $0 de valor en libros (equivale a 3 años de vida útil).
                  </span>
                }
              />
              <FormItem
                name="metodoDepreciacionDefault"
                label="Método de Depreciación"
                required
                margin
                initialValue={1}
                tooltip={{ title: "Método por default para calcular la depreciación de los Activos de este tipo. Por ahora solo está implementada Línea Recta." }}
              >
                <SelectItem placeholder="Método de Depreciación">
                  <Option value={1}>Línea recta</Option>
                </SelectItem>
              </FormItem>
              <FormItem
                name="frecuenciaDepreciacionDefault"
                label="Frecuencia de Depreciación"
                required
                margin
                initialValue={1}
                tooltip={{ title: "Cada cuánto se corre la depreciación: Mensual, Bimestral (cada 2 meses), Trimestral (cada 3), Semestral (cada 6) o Anual (cada 12)." }}
              >
                <SelectItem placeholder="Frecuencia de Depreciación">
                  <Option value={1}>Mensual</Option>
                  <Option value={2}>Bimestral</Option>
                  <Option value={3}>Trimestral</Option>
                  <Option value={4}>Semestral</Option>
                  <Option value={5}>Anual</Option>
                </SelectItem>
              </FormItem>
              <FormItem
                name="porcentajeDepreciacionAnualDefault"
                label="Depreciación Anual (%)"
                required
                margin
                tooltip={{ title: "Qué porcentaje del costo (menos el valor residual) se deprecia cada año, ej. 10% anual = 10 años de vida útil. Es la tasa que usan las tablas de depreciación del SAT — se convierte internamente a meses." }}
              >
                <InputNumberItem placeholder="Ej. 10" porcentaje min={0.01} max={100} />
              </FormItem>
              <FormItem
                name="valorResidualDefaultPorcentaje"
                label="Valor Residual"
                margin
                initialValue={0}
                tooltip={{ title: "% del costo que NUNCA se deprecia (lo que se espera que valga el activo al final de su vida útil). Ej. 10% de $10,000 = $1,000 de valor residual." }}
              >
                <InputNumberItem placeholder="Ej. 10" porcentaje min={0} max={100} />
              </FormItem>
            </div>

            <div ref={this.refFolio}>
              <FormItem
                name="prefijoSerieActivo"
                label="Prefijo de Serie"
                margin
                pattern
                tooltip={{ title: "Texto fijo antes del folio consecutivo de cada unidad, ej. 'MOB-' produce folios MOB-00001, MOB-00002..." }}
              >
                <InputItem placeholder="Ej. MOB-" />
              </FormItem>
              <FormItem
                name="longitudFolioActivo"
                label="Longitud de Folio"
                margin
                initialValue={5}
                tooltip={{ title: "Cantidad de dígitos del consecutivo, rellenando con ceros a la izquierda. Ej. longitud 5 → 00042." }}
              >
                <InputNumberItem placeholder="Ej. 5" min={1} max={10} />
              </FormItem>
            </div>
          </Form>
        </ModalItem>
        <AgregarCuentaContable
          visible={this.state.modalAgregarCuentaContable}
          cerrarAgregarCuentaContable={this.cerrarAgregarCuentaContable.bind(this)}
        />
        <TourItem open={this.state.openTour} onClose={() => this.setState({ openTour: false })} steps={steps} />
        <AsistenteDepreciacionLISR
          visible={this.state.openAsistenteDepreciacion}
          onClose={() => this.setState({ openAsistenteDepreciacion: false })}
          onAplicar={({ porcentaje, metodo }) =>
            this.formRef.current.setFieldsValue({
              porcentajeDepreciacionAnualDefault: porcentaje,
              metodoDepreciacionDefault: metodo,
            })
          }
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(AgregarTipoDeActivo);
